import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function initGTM() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (document.getElementById('gtm-script')) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  });
  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-57T5K5XG';
  script.src = 'https://widgets.binotel.com/getcall/widgets/96bnfdxdlw4s3r6lnwoa.js';
  document.head.appendChild(script);
})();
render(<App data-id="element-362" data-mp="2p0bhywvswrna" />, document.getElementById('root'));